<ngx-smart-modal #onboardingModal identifier="resumeCompletionOnboarding"
  customClass="resume-onboarding-modal" [closable]="false" [escapable]="true" [dismissable]="true"
  ariaLabelledBy="resume-onboarding-title" ariaDescribedBy="resume-onboarding-description"
  (onAnyCloseEvent)="handleClose()">
  <article class="resume-onboarding" dir="rtl" role="dialog" aria-modal="true"
    aria-labelledby="resume-onboarding-title" aria-describedby="resume-onboarding-description">
    <button type="button" class="resume-onboarding__close" aria-label="بستن پنجره" (click)="close()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>

    <img *ngIf="!hasCompleteResume" class="resume-onboarding__illustration"
      src="/assets/images/onboarding/resume-completion.png" alt="" aria-hidden="true">
    <img *ngIf="hasCompleteResume" class="resume-onboarding__illustration resume-onboarding__illustration--vanguard"
      src="/assets/images/onboarding/vanguard-more-offers-v2.png" alt="" aria-hidden="true">

    <h2 id="resume-onboarding-title" class="resume-onboarding__title">
      <ng-container *ngIf="!hasCompleteResume">
        یه رزومه کامل، یه قدم نزدیک‌تر به استخدام!
      </ng-container>
      <ng-container *ngIf="hasCompleteResume">پیشتاز باش؛ رزومه‌ات زودتر دیده می‌شه.</ng-container>
    </h2>

    <p id="resume-onboarding-description" class="resume-onboarding__description">
      <ng-container *ngIf="!hasCompleteResume">
        اطلاعات رزومه‌ات هنوز کامل نیست
سوابق و شغل‌های موردعلاقه‌ات رو اضافه کن تا پیشنهادهای دقیق‌تری بگیری و کارفرما بتونه راحت‌تر پیدات کنه.
      </ng-container>
      <ng-container *ngIf="hasCompleteResume">
        با بسته <strong>کارجوی پیشتاز</strong>، هر روز جدیدترین آگهی‌های استخدام را از طریق پیامک دریافت کن و
        زودتر از دیگران از فرصت‌های شغلی باخبر شو.
      </ng-container>
    </p>

    <div class="resume-onboarding__actions">
      <button type="button" class="btn" [class.btn-primary]="!hasCompleteResume"
        [class.btn-vanguard]="hasCompleteResume" (click)="primaryAction()">
        {{hasCompleteResume ? 'همین حالا پیشتاز شو' : 'تکمیل رزومه'}}
        <i class="fas fa-arrow-left mr-2" aria-hidden="true"></i>
      </button>
      <button type="button" class="btn btn-secondary" (click)="postpone()">بعداً</button>
    </div>
  </article>
</ngx-smart-modal>
